/*
 * Enumeration of all Equality relation types
 */
export enum EqualityRelation {
  LESS_THAN = '<',
  LESS_THAN_OR_EQUAL_TO = '<=',
  EQUAL = '=',
  NOT_EQUAL = '<>',
  GREATER_THAN = '>',
  GREATER_THAN_OR_EQUAL_TO = '>=',
  PARTIAL = '~',
  CONTAINS = '@>'
}
